export const AI_AGENT_HISTORY_TYPES = {
  ALL: 'all',
  CREATE: 'CREATE',
  RELEARN: 'RELEARN',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
} as const;

export const AI_AGENT_HISTORY_TYPE_LABELS: Record<string, string> = {
  [AI_AGENT_HISTORY_TYPES.ALL]: '전체',
  [AI_AGENT_HISTORY_TYPES.CREATE]: '생성',
  [AI_AGENT_HISTORY_TYPES.RELEARN]: '재학습',
  [AI_AGENT_HISTORY_TYPES.UPDATE]: '수정',
  [AI_AGENT_HISTORY_TYPES.DELETE]: '삭제',
};

export const manualHistoryTypeOptions = [
  { value: AI_AGENT_HISTORY_TYPES.ALL, label: AI_AGENT_HISTORY_TYPE_LABELS[AI_AGENT_HISTORY_TYPES.ALL] },
  { value: AI_AGENT_HISTORY_TYPES.CREATE, label: AI_AGENT_HISTORY_TYPE_LABELS[AI_AGENT_HISTORY_TYPES.CREATE] },
  { value: AI_AGENT_HISTORY_TYPES.RELEARN, label: AI_AGENT_HISTORY_TYPE_LABELS[AI_AGENT_HISTORY_TYPES.RELEARN] },
  { value: AI_AGENT_HISTORY_TYPES.UPDATE, label: AI_AGENT_HISTORY_TYPE_LABELS[AI_AGENT_HISTORY_TYPES.UPDATE] },
  { value: AI_AGENT_HISTORY_TYPES.DELETE, label: AI_AGENT_HISTORY_TYPE_LABELS[AI_AGENT_HISTORY_TYPES.DELETE] },
] as const;

export const modelHistoryTypeOptions = [
  { value: AI_AGENT_HISTORY_TYPES.ALL, label: AI_AGENT_HISTORY_TYPE_LABELS[AI_AGENT_HISTORY_TYPES.ALL] },
  { value: AI_AGENT_HISTORY_TYPES.CREATE, label: AI_AGENT_HISTORY_TYPE_LABELS[AI_AGENT_HISTORY_TYPES.CREATE] },
  { value: AI_AGENT_HISTORY_TYPES.UPDATE, label: AI_AGENT_HISTORY_TYPE_LABELS[AI_AGENT_HISTORY_TYPES.UPDATE] },
  { value: AI_AGENT_HISTORY_TYPES.DELETE, label: AI_AGENT_HISTORY_TYPE_LABELS[AI_AGENT_HISTORY_TYPES.DELETE] },
] as const;
